export default __webpack_public_path__ + "static/media/23.b5cfac66.png";